import { SettingsManager } from '@shared/app/scripts/services/settings-manager';

/**
 * @ngdoc service
 * @name posApp.pos
 * @description
 * Service that contains rules for available payment types
 */
angular
  .module('posApp')
  .factory(
    'paymentTypes',
    (
      settingsManager: SettingsManager,
      translate: ng.translate.ITranslateService,
    ) => {
      const paymentTypes: any = {},
        $translate = translate;

      function updateSettings(currentSettings: any) {
        paymentTypes.rules = {
          cash: {
            active: currentSettings.paymentMethods?.cash?.available,
            allow_neg: currentSettings.paymentMethods?.cash?.allowNegative,
            allow_pos: true,
            article: true,
            coupled: false,
            customer: currentSettings.paymentMethods?.cash?.requireCustomer,
            display: $translate.instant('Contant'),
            readOnly: false,
            reason: false,
            turnover: '+',
            type: 'cash',
          },
          consignment: {
            active: currentSettings.paymentMethods?.consignment?.available,
            allow_neg: false,
            allow_pos: true,
            article: true,
            coupled: false,
            customer: true,
            display: $translate.instant('Op zicht'),
            readOnly: false,
            reason: false,
            turnover: 'none',
            type: 'other',
          },
          creditcard: {
            active: currentSettings.paymentMethods?.creditCard?.available,
            allow_neg:
              currentSettings.paymentMethods?.creditCard?.allowNegative,
            allow_pos: true,
            article: true,
            coupled: false,
            customer:
              currentSettings.paymentMethods?.creditCard?.requireCustomer,
            display: $translate.instant('Creditcard'),
            readOnly: false,
            reason: false,
            turnover: '+',
            type: 'electronic',
          },
          creditreceipt: {
            active: currentSettings.paymentMethods?.creditReceipt?.available,
            allow_neg: true,
            allow_pos: false,
            article: true,
            coupled: false,
            customer:
              currentSettings.paymentMethods?.creditReceipt?.requireCustomer,
            display: $translate.instant('Tegoedbon uit'),
            readOnly: true,
            reason: false,
            turnover: '+',
            type: 'other',
          },
          pin: {
            active: currentSettings.paymentMethods?.pin?.available,
            allow_neg: currentSettings.paymentMethods?.pin?.allowNegative,
            allow_pos: true,
            article: true,
            coupled: currentSettings.paymentMethods?.pin?.coupled,
            customer: currentSettings.paymentMethods?.pin?.requireCustomer,
            display: $translate.instant('PIN'),
            readOnly: false,
            reason: false,
            turnover: '+',
            type: 'electronic',
          },
          storecredit: {
            active: currentSettings.paymentMethods?.storeCredit?.available,
            allow_neg: true,
            allow_pos: true,
            article: true,
            coupled: false,
            customer:
              currentSettings.paymentMethods?.storeCredit?.requireCustomer,
            display: $translate.instant('Op rekening'),
            readOnly: true,
            reason: false,
            turnover: '+',
            type: 'other',
          },
          withdrawel: {
            active: currentSettings.paymentMethods?.withdrawal?.available,
            allow_neg: true,
            allow_pos: true,
            article: false,
            coupled: false,
            customer: false,
            display: $translate.instant('Kasopname'),
            readOnly: true,
            reason: true,
            turnover: '+',
            type: 'cash',
          },
        };
      }

      settingsManager.settings$.subscribe(updateSettings);

      updateSettings(settingsManager.settings);

      return paymentTypes;
    },
  );
